import { FormsConstants } from './constants'

import { reducer as reduxFormReducer } from 'redux-form'
export const formReducer = reduxFormReducer.plugin({
  [FormsConstants.formNames.ISSUE_FORM]: (state, action) => {
    switch (action.type) {
      default:
        return state
    }
  },
})
